<template>
  <div class="pt-3 pb-4">
    <Common ref="common" />
    <PrimaryDetails
      :mbr="memDetails"
      class="mb-2"
      @showResponse="showResponse"
    />
    <AddressDetails
      :mbr="memDetails"
      class="mb-2"
      @showResponse="showResponse"
    />
    <!-- <BankDetails class="mb-2"/> -->
    <NomineeDetails
      :mbr="memDetails"
      class="mb-2"
      @showResponse="showResponse"
    />
  </div>
</template>
<script>
import { callApi } from "@/api/others";
export default {
  components: {
    PrimaryDetails: () =>
      import("@/components/wesupport/member/primaryDetails/PrimaryDetails.vue"),
    AddressDetails: () =>
      import("@/components/wesupport/member/addressDetails/AddressDetails.vue"),
    BankDetails: () =>
      import("@/components/wesupport/member/bankDetails/BankDetails.vue"),
    NomineeDetails: () =>
      import("@/components/wesupport/member/nomineeDetails/NomineeDetails.vue"),
    Common: () => import("@/components/tools/common.vue"),
  },
  data: () => ({
    memDetails: {
      person: {
        postalAddress:{}
      },
    },
    response: "",
  }),
  mounted() {
    this.$emit("changeHeader", "Member");
    this.getMemDetails();
  },
  methods: {
    getMemDetails() {
      this.dpLoading = true;
      let url = `/api/wesupport/Member/getbyid`;
      let data = {
        id: this.decryptMemId(),
      };
      callApi(url, "post", data)
        .then((res) => {
          this.memDetails = res.data.data;
        })
        .catch((err) => {
          this.$refs.common.ManageResponse(err.response);
        })
        .finally(() => {
          this.dpLoading = false;
        });
    },
    showResponse(res, refresh = true) {
      this.$refs.common.ManageResponse(res);
      if (refresh) {
        this.getMemDetails();
      }
    },
  },
};
</script>
